import { SchemaDeSerBuilder } from "./deser"

export class ZeroHashClientAuthToken {
  token = ""
}

export enum ZeroHashPermission {
  ACCOUNT_LINK = "crypto-account-link",
  WITHDRAWALS = "crypto-withdrawals",
  FWC = "fwc",
}

export enum ZeroHashAccountLinkSdkEvents {
  CRYPTO_ACCOUNT_LINK_EXTERNAL_ACCOUNT_CREATED = "CRYPTO_ACCOUNT_LINK_EXTERNAL_ACCOUNT_CREATED",
}

export enum ZeroHashWithdrawalSdkEvents {
  CRYPTO_WITHDRAWALS_COMPLETED = "CRYPTO_WITHDRAWALS_COMPLETED",
  CRYPTO_WITHDRAWALS_CLOSE_BUTTON_CLICKED = "CRYPTO_WITHDRAWALS_CLOSE_BUTTON_CLICKED",
}

export const ZERO_HASH_CLIENT_AUTH_TOKEN_DESER = new SchemaDeSerBuilder(
  ZeroHashClientAuthToken
)
  .ofString("token")
  .toDeSer()
